<template>
  <div class="main">
      <div class="connexion-section">
      <div class="image_connexion">
          <img src="../assets/logo/logo-PREVENTMS2.png" alt="logo PreventTms" class="img_co">
      </div>
      <form action="" method="post" class="loggin_form">
            <label for="mailUser" v-if="mailConfirm == false">Notez Votre Email ici !</label><br/>
            <input type="text" placeholder="Identifiant" name="email" class="id" id="mailUser" autocomplete = "username email" v-if="mailConfirm == false" >
            
            <div class="step2Mdp" v-else-if="mailConfirm !== false">
            <input type="text" name="username" :value="this.user.mail" autocomplete = "username" id="real-username" readonly="readonly" style="display:none;"/>
            <div class="wrapPortable Indica"><h2 class="indH2">Changement de Mot de passe</h2><br/></div>
            
            <label for="password" v-if="path3 == false" >Notez votre nouveau mots de passe puis confirmer-le !</label>
            <label for="password" v-if="path3 == true" >La sécurité est importante nous vous recommandons d'utiliser un mots de passe d'au moins 8 caractères avec 1 Majuscule 1 Chiffre et 1 caractère speciale.</label><br/>
            <input name="password" id="password" type="password" @keyup.prevent="check()" class="mdp" autocomplete = "new-password"  />
            <input type="password" name="confirm_password" id="confirm_password" class="mdp" @keyup.prevent="check()" autocomplete = "new-password" />
            <br/> 
            <span id='message'></span>
            </div>
            

            <button class="connexion-submit" @click.prevent="postInfoMail()" v-if="mailConfirm == false">Confirmation email</button>
            <button class="connexion-submit" @click.prevent="postInfoChangePass()" v-else>Changement mots de passe</button> 
      </form>
      </div>
  </div>
</template>

<script>
import { User } from "../controller/user.js";
import { hostUrl } from "../_helpers/global_var";

const axios = require('axios').default;

export default {
  name: "Changement_Mdp",
  data() {
    return {
        user: new User,
        remember_me: false,
        mailConfirm: false,
        path2: false,
        path3: false,
        
    };
  },
  beforeRouteEnter (to, from, next) {
    try {
      var id = to.params.id;
      console.log(id)
    } catch (error) {
      var id = null;
    }
    
    if (id !== null){
      try {
          axios
            .get(hostUrl+'/etat/salarie/'+salarie_id)
            .then(function(response){
              console.log(response);
              if (response.data == false){
                next('/connexion');
              }else{
                next();
              }
            })
            .catch(error => console.log(error));
            
      } catch (error) {
        next();
      }
    }
 
  },
  created (){ 
        if (typeof(localStorage.user) !== undefined && localStorage.length > 1 ){
            if (localStorage.user.mail !== undefined){
                this.user = JSON.parse(localStorage.user);
                //console.log('ok',this.user);
                this.mailConfirm = true; 
            }
          
        }else if (typeof(localStorage.user) === undefined){
          console.log('var not exist');
        }else{
          console.log('ko');
        }
        if (this.$route.params.id !== undefined && this.$route.name !== 'Changement_Mdp3'){
          console.log(this.$route.name)
            this.user.id = this.$route.params.id;
            this.mailConfirm = true;
            this.path2 = true;
        }else if (this.$route.params.id !== undefined && this.$route.name == 'Changement_Mdp3'){
            this.user.id = this.$route.params.id;
            this.mailConfirm = true;
            console.log(this.user.id, this.$route.name)
            this.path3 = true;
        }
    },
  methods: {
      async postInfoMail(){
        this.user.mail = document.getElementById('mailUser').value;
        let json = JSON.stringify({mail : this.user.mail});
        //console.log(json);
        await axios
            .post(hostUrl+'/salarie/edit/newPass1', json)
            .then(response => alert(response.data))
            .catch(error => console.log(error));

        

      },
      async postInfoChangePass(){
        if (document.getElementById('message').innerHTML == 'Mots de passes fort, Mots de passes identiques' || document.getElementById('message').innerHTML == 'Mots de passes correct, Mots de passes identiques'){
            let json2 ="";
            this.user.newPass = document.getElementById('confirm_password').value;
            
            if (this.path2 == true){
               json2 = JSON.stringify({id : this.user.id, password: this.user.newPass}); 
            }else if (this.path3 == true){
               json2 = JSON.stringify({id : this.user.id, password: this.user.newPass, firstCo: true}); 
            }else{
               json2 = JSON.stringify({id : this.user.user_id, password: this.user.newPass});
            }
            console.log(json2);
        
        
          await axios
            .post(hostUrl+'/salarie/edit/newPass2', json2)
            .then(response => this.userOk(response, this.user.newPass))
            .catch(error => console.log(error))
            .catch(error => alert('Le temps pour changer votre mots de passe est écoulé, allez dans mots de passe oublié si vous vous en souvenez plus.'))
            ;
        }
      },
      userOk (response, pass){
          let koko = new User (response.data);
          koko.password = pass;
          localStorage.user = JSON.stringify(koko);
          if (koko.poids == null && this.path3 == false || koko.taille == null && this.path3 == false){
            this.$router.push({ name: 'Questionnaire' });
          }else if (this.path3 == true){
            this.$router.push({ name: 'log-out' });
          }else{
            this.$router.push({ name: 'Accueil' });
          }
      },
      check() {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
        var pass = document.getElementById('password').value;
        //console.log(pass);
        
        if(strongRegex.test(pass)) {
          document.getElementById('message').style.color = '#54c7da';
          document.getElementById('message').innerHTML = 'Mots de passes fort';
          if (document.getElementById('password').value == document.getElementById('confirm_password').value) {
            document.getElementById('message').style.color = '#54c7da';
            document.getElementById('message').innerHTML = 'Mots de passes fort, Mots de passes identiques';
        } else {
            document.getElementById('message').style.color = '#c41316';
            document.getElementById('message').innerHTML = 'Mots de passes fort, Mots de passes non identiques';
        }
        } else if(mediumRegex.test(pass)) {
          document.getElementById('message').style.color = '#54c7da';
          document.getElementById('message').innerHTML = 'Mots de passes correct';
          if (document.getElementById('password').value == document.getElementById('confirm_password').value) {
            document.getElementById('message').style.color = '#54c7da';
            document.getElementById('message').innerHTML = 'Mots de passes correct, Mots de passes identiques';
        } else {
            document.getElementById('message').style.color = '#c41316';
            document.getElementById('message').innerHTML = 'Mots de passes correct, Mots de passes non identiques';
        }
        } else {
          document.getElementById('message').style.color = '#c41316';
          document.getElementById('message').innerHTML = 'Mots de passes très faibles';
        }
        
      },
     
  },
};
</script>
<style>
  
</style>


// WEBPACK FOOTER //
// src/components/Mdp.vue